import axios from 'axios'

import type { WebshopPackage } from '../../../schema/webshop-package'
import { getApiUrl, PAYMENT_WEBSHOP_URL } from '../../util/api/api'

const addProductToBasket = (product: WebshopPackage) =>
  axios.post<{ productId: string }>(
    getApiUrl(`${PAYMENT_WEBSHOP_URL}/addToBasket`),
    {
      productId: product.productCode,
    },
    { withCredentials: true },
  )

export default addProductToBasket
